export default __webpack_public_path__ + "signup.2c87b2198a05e0b07ad184a72450714f.png";